import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getUserPreferences } from '../services/userPreferences';
import { mergeLocaleChain } from './mergeLocales';
import frBase from './locales/fr.json';
import enBase from './locales/en.json';
import esBase from './locales/es.json';
import statusFr from './locales/partials/status.json';
import statusEn from './locales/partials/status.en.json';
import statusEs from './locales/partials/status.es.json';
import filtersFr from './locales/partials/filters.json';
import filtersEn from './locales/partials/filters.en.json';
import filtersEs from './locales/partials/filters.es.json';
import formsFr from './locales/partials/forms.json';
import formsEn from './locales/partials/forms.en.json';
import formsEs from './locales/partials/forms.es.json';
import authExtraFr from './locales/partials/auth-extra.json';
import authExtraEn from './locales/partials/auth-extra.en.json';
import authExtraEs from './locales/partials/auth-extra.es.json';
import pagesFr from './locales/partials/pages.json';
import pagesEn from './locales/partials/pages.en.json';
import pagesEs from './locales/partials/pages.es.json';
import uiFr from './locales/partials/ui.json';
import uiEn from './locales/partials/ui.en.json';
import uiEs from './locales/partials/ui.es.json';
import publicPagesFr from './locales/partials/public-pages.json';
import publicPagesEn from './locales/partials/public-pages.en.json';
import publicPagesEs from './locales/partials/public-pages.es.json';
import guideFaqFr from './locales/partials/guide-faq.fr.json';
import guideFaqEn from './locales/partials/guide-faq.en.json';
import guideFaqEs from './locales/partials/guide-faq.es.json';
import notificationMessagesFr from './locales/partials/notification-messages.json';
import notificationMessagesEn from './locales/partials/notification-messages.en.json';
import notificationMessagesEs from './locales/partials/notification-messages.es.json';
import toastsFr from './locales/partials/toasts.json';
import toastsEn from './locales/partials/toasts.en.json';
import toastsEs from './locales/partials/toasts.es.json';
import activitiesFr from './locales/partials/activities.json';
import activitiesEn from './locales/partials/activities.en.json';
import activitiesEs from './locales/partials/activities.es.json';
import notificationRichFr from './locales/partials/notification-rich.json';
import notificationRichEn from './locales/partials/notification-rich.en.json';
import notificationRichEs from './locales/partials/notification-rich.es.json';
import screensFr from './locales/partials/screens.json';
import screensEn from './locales/partials/screens.en.json';
import screensEs from './locales/partials/screens.es.json';

const fr = mergeLocaleChain(frBase, statusFr, filtersFr, formsFr, authExtraFr, pagesFr, uiFr, publicPagesFr, guideFaqFr, notificationMessagesFr, notificationRichFr, toastsFr, activitiesFr, screensFr);
const en = mergeLocaleChain(enBase, statusEn, filtersEn, formsEn, authExtraEn, pagesEn, uiEn, publicPagesEn, guideFaqEn, notificationMessagesEn, notificationRichEn, toastsEn, activitiesEn, screensEn);
const es = mergeLocaleChain(esBase, statusEs, filtersEs, formsEs, authExtraEs, pagesEs, uiEs, publicPagesEs, guideFaqEs, notificationMessagesEs, notificationRichEs, toastsEs, activitiesEs, screensEs);

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  es: { translation: es }
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: getUserPreferences().language,
    fallbackLng: 'fr',
    interpolation: { escapeValue: false },
    returnEmptyString: false,
    compatibilityJSON: 'v3'
  });
}

export const changeAppLanguage = (language) => {
  const lng = ['fr', 'en', 'es'].includes(language) ? language : 'fr';
  return i18n.changeLanguage(lng);
};

export default i18n;
